import React from 'react';
import PropTypes from 'prop-types';
import NBAInsightEntity from '../../entities/nba/NBAInsightEntity';
import NBABL from './NBABL';

class ProductCard extends React.Component {
  constructor(props) {
    super(props);
    this.handleAction = this.handleAction.bind(this);
    this.state = this.getState();
  }
  getState() {
    return { viewData: this.props.data[0] };
  }
  handleAction(e) {
    e.preventDefault();
    this.props.action(this.state.viewData);
  }
  render() {
    const image = NBABL.getCompletePath(this.state.viewData.icon);
    return (
      this.state.viewData.isTextContent && (
        <div className="l-tile c-product">
          {image && (
            <div className="c-product__media">
              <img src={image} alt="" />
            </div>
          )}
          <div className="c-product__body">
            {this.state.viewData.textHeader && (
              <h3 className="c-product__title">
                {this.state.viewData.textHeader}
              </h3>
            )}
            {this.state.viewData.textValue && (
              <p
                className="c-product__text"
                dangerouslySetInnerHTML={{
                  __html: this.state.viewData.textValue,
                }}
              />
            )}
            {this.state.viewData.isAction && (
              <div className="c-product__button">
                <a
                  aria-haspopup="true"
                  className="c-product__link"
                  href="javascript:;"
                  onClick={this.handleAction}
                >
                  {NBABL.getButtonText(this.state.viewData)}
                </a>
              </div>
            )}
          </div>
        </div>
      )
    );
  }
}
ProductCard.propTypes = {
  data: PropTypes.arrayOf(PropTypes.objectOf(NBAInsightEntity)).isRequired,
  action: PropTypes.func,
};
export default ProductCard;
